import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Asegúrate de importar useLocation

function ScrollToTop() {
    const { pathname } = useLocation(); // Obtiene la ruta actual

    useEffect(() => {
        // Cuando el pathname (ruta) cambia, desplázate a la parte superior.
        window.scrollTo(0, 0);
    }, [pathname]); // El efecto se vuelve a ejecutar cada vez que pathname cambia

    return null; // Este componente no renderiza nada en el DOM
}

export default ScrollToTop;